class Notification {
    constructor(message, type) {
        this.message = message;
        this.type = type;
        this.controller();
    }

    controller() {
        const existingNotification = document.querySelector('.vg-notification');

        if (existingNotification) {
            setTimeout(() => {
                existingNotification.remove();
                this.render()
            }, 1000);
        }else{
            this.render();
        }
    }

    render() {
        const notification = document.createElement('div');
        notification.className = `vg-notification ${this.type}`;
        notification.innerHTML = `
            <span class="vg-notification__message">${this.message}</span>
            <span class="vg-notification__close-icon"></span>
        `;

        notification.querySelector('.vg-notification__close-icon').addEventListener('click', () => {
            this.close(notification);
        });

        let joiningForm = document.querySelector('.vg-joining-process__list-steps');
        joiningForm.appendChild(notification);

        setTimeout(() => {
            this.close(notification);
        }, 2000);
    }

    close(notification) {
        notification.remove();
    }
}

export { Notification };